// Shared "Add to campaign" / "Open in…" data — used by both the Asset Detail
// Drawer (single asset) and the Clip Selection Bar (multi-select), so the two
// surfaces can't drift apart. Mock data — matches the design mock, not a real
// backend feed yet.

export interface Campaign {
  id: string;
  label: string;
  avatar: string;
  color: string;
  assetCount: number;
  status: string;
}

export const MOCK_CAMPAIGNS: Campaign[] = [
  { id: 'azure-ignite', label: 'Azure Ignite — Customer S…', avatar: 'M', color: '#2E7BF6', assetCount: 24, status: 'In production' },
  { id: 'sumo-logic', label: 'Sumo Logic — Product Sto…', avatar: 'S', color: '#12B886', assetCount: 6, status: 'In review' },
  { id: 'bgc', label: 'BGC — Employer Brand Fil…', avatar: 'B', color: '#2E7BF6', assetCount: 5, status: 'In production' },
  { id: 'nordics', label: 'Nordics Expansion — Even…', avatar: 'V', color: '#2E7BF6', assetCount: 4, status: 'Wrapping' },
];

export interface OpenInApp {
  key: string;
  label: string;
  icon: JSX.Element;
}

export const OPEN_IN_APPS: OpenInApp[] = [
  {
    key: 'story-builder',
    label: 'Story Builder',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 2 7 12 12 22 7 12 2" />
        <polyline points="2 17 12 22 22 17" />
        <polyline points="2 12 12 17 22 12" />
      </svg>
    ),
  },
  {
    key: 'premiere',
    label: 'Premiere',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="18" rx="2" />
        <path d="M7 3v18M17 3v18M2 9h5M17 9h5M2 15h5M17 15h5" />
      </svg>
    ),
  },
  {
    key: 'canva',
    label: 'Canva',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="8" height="8" rx="1.5" />
        <rect x="13" y="3" width="8" height="8" rx="1.5" />
        <rect x="3" y="13" width="8" height="8" rx="1.5" />
        <rect x="13" y="13" width="8" height="8" rx="1.5" />
      </svg>
    ),
  },
];
